import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[appCardNumberMask]'
})
export class CardNumberMaskDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('focus')
  onFocus(): void {
    const value = this.control?.control?.value || '';
    this.el.nativeElement.value = this.formatWithSpaces(value.replace(/\D/g, ''));
  }

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;
    const digits = input.value.replace(/\D/g, '');
    input.value = this.formatWithSpaces(digits);
    if (this.control && this.control.control) {
      this.control.control.setValue(digits, { emitEvent: false });
    }
  }

  @HostListener('blur')
  onBlur(): void {
    const value = this.control?.control?.value || '';
    const digits = value.replace(/\D/g, '');
    let masked = digits;
    if (digits.length > 4) {
      masked = '*'.repeat(digits.length - 4) + digits.slice(-4);
    }
    this.el.nativeElement.value = this.formatWithSpaces(masked);
  }

  private formatWithSpaces(value: string): string {
    return value.replace(/(.{4})/g, '$1 ').trim();
  }
}
